/**
 * Cliente HTTP para faixas de frete local (ERP Configurações).
 */

import api from './api'

export const shippingZonesService = {
  list: async (params = {}) => {
    const response = await api.get('/api/settings/shipping-zones', { params })
    return response.data
  },

  getById: async (id) => {
    const response = await api.get(`/api/settings/shipping-zones/${id}`)
    return response.data
  },

  create: async (payload) => {
    const response = await api.post('/api/settings/shipping-zones', payload)
    return response.data
  },

  update: async (id, payload) => {
    const response = await api.put(`/api/settings/shipping-zones/${id}`, payload)
    return response.data
  },

  deactivate: async (id) => {
    const response = await api.delete(`/api/settings/shipping-zones/${id}`)
    return response.data
  },

  quoteTest: async (cep) => {
    const response = await api.post('/api/settings/shipping-zones/quote-test', { cep })
    return response.data
  },
}
